import PropTypes from "prop-types";

import styles from "./PastActionsList.module.css";

import PastActionItem from "../PastActionItem";

export function PastActionsList({ pastActions }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Incident #</div>
        <div>Type</div>
        <div className={styles.lastItemDate}>Date</div>
      </div>

      {pastActions.map((item, index) => (
        <div key={index}>
          <PastActionItem
            index={index}
            actionDetails={item}
            onClick={() => {}}
          />
        </div>
      ))}
    </div>
  );
}

PastActionsList.propTypes = {
  pastActions: PropTypes.arrayOf(PropTypes.object),
};
